import styled from "styled-components";

const FormContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-top: 1px solid #bdbdbd;
`;

export default FormContainer;



// WEBPACK FOOTER //
// ./src/components/FormComponents/FormContainer.tsx